import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [userid, setUserId] = useState(localStorage.getItem('userid') || '');
  const [username, setUserNameData] = useState(localStorage.getItem('username') || '');
  const [moduleAccess, setModuleAccess] = useState(
    JSON.parse(localStorage.getItem('moduleAccess')) || {}
  );

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  useEffect(() => {
    if (userid) {
      localStorage.setItem('userid', userid);
    } else {
      localStorage.removeItem('userid');
    }
  }, [userid]);

  useEffect(() => {
    if (username) {
      localStorage.setItem('username', username);
    } else {
      localStorage.removeItem('username');
    }
  }, [username]);

  useEffect(() => {
    if (moduleAccess) {
      localStorage.setItem('moduleAccess', JSON.stringify(moduleAccess));
    } else {
      localStorage.removeItem('moduleAccess');
    }
  }, [moduleAccess]);

  const logout = () => {
    setToken('');
    setUserId('');
    setUserNameData('');
    setModuleAccess({});
    localStorage.removeItem('token');
    localStorage.removeItem('userid');
    localStorage.removeItem('username');
    localStorage.removeItem('moduleAccess');
  };

  return (
    <AuthContext.Provider 
      value={{ token, setToken, userid, setUserId, username, setUserNameData, moduleAccess, setModuleAccess, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
